import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Typography, FormControlLabel } from "@mui/material";
import PrimaryCheckbox from "../../../../Inputs/PrimaryCheckBox/PrimaryCheckBox";

export default function CarrierProfileAddEquipmentItem({ equipment, existingTypes, handleAddType, handleRemoveType}) {
  const [checked, setChecked] = useState(false);
  const [typeExists, setTypeExists] = useState(false);

  const handleChange = (e) => {
    setChecked(!checked);
    if (e.target.checked) {
      handleAddType(equipment);
    } else {
      handleRemoveType(equipment);
    }
  };

  useEffect(() => {
    setTypeExists(!!existingTypes.find(type => type.equipmentTypeId === equipment.id));
  }, [equipment, existingTypes]);

  return (
    <Box 
      key={`equipment-type-${equipment.id}`}
      sx={{ display: "flex", alignItems: "center" }}
    >
      <FormControlLabel
        sx={{
          marginBottom: "12px"
        }} 
        control={
          <Box sx={{ margin: "0 8px 0px 8px"}}>
            <PrimaryCheckbox 
              checked={checked}
              handleChange={(event) => handleChange(event)}
              disabled={typeExists}
            />
          </Box>
        }
        label={
          <Typography variant="body1" color="black_opacity.100">
            {equipment.descr}
          </Typography>
        }
      />
    </Box>
  );
}

CarrierProfileAddEquipmentItem.propTypes = {
  equipment: PropTypes.object.isRequired,
  existingTypes: PropTypes.array.isRequired,
  handleAddType: PropTypes.func.isRequired,
  handleRemoveType: PropTypes.func.isRequired
};